<template>
    <!--<div style="padding-top: 0.6rem">-->
        <!--<div :id="name" :style="{width: '100%', height: '300px'}"></div>-->
    <!--</div>-->
</template>
  <script>
  // 引入基本模板
  // const echarts = require('echarts');
  // 引入柱状图组件
  // require('echarts/lib/chart/bar')
  // 引入提示框和title组件
  // require('echarts/lib/component/tooltip')
  // require('echarts/lib/component/title')
  // require ("echarts/lib/chart/line");

  export default {
    name: "gameEcharts",
    props: {
      title: String,

      list:Object,
        name:String,
    },
    components:{

    },
    data: function() {
      return {

      };
    },
      mounted(){
          // this.drawLine();
      },
    methods: {
        // drawLine(){
        //     // 基于准备好的dom，初始化echarts实例
        //     let myChart =  echarts.init(document.getElementById(this.name))
        //     // 绘制图表
        //     myChart.setOption(this.list);
        // }
    }
  };
  </script>
  <style scoped>
    /*.A{*/
        /*text-align: center;*/
    /*}*/

  </style>
